import { Logo } from '@/components/Logo';
import { useGetConfig } from '@/services/queries/admin-config';
import { Box, Flex, Heading, Skeleton, Text, useBreakpointValue } from '@chakra-ui/react';
import { PropsWithChildren, ReactNode } from 'react';

export interface AuthFormBaseContainerProps {
  title: ReactNode;
  description?: ReactNode;
}

export const AuthFormBaseContainer = ({ children, title, description }: PropsWithChildren<AuthFormBaseContainerProps>) => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  } as const);

  const { data: config, isLoading } = useGetConfig();

  return (
    <Flex direction='column' flex={1}>
      <Flex justify='center' align='center' flexGrow={1}>
        <Flex direction='column' maxW='550px' w='full' gap='40px' align='stretch'>
          <Box textAlign='center'>
            {isMobile ? (
              <Flex justifyContent='center' mb={12}>
                <Logo variant='colorful' maxWidth={140} />
              </Flex>
            ) : null}
            <Heading color='brand.500'>{title}</Heading>
            {description ? (
              <Text maxW={400} marginTop={2} marginX='auto' color='brand.500' fontSize='16px'>
                {description}
              </Text>
            ) : null}
          </Box>

          {children}
        </Flex>
      </Flex>

      {isLoading && (
        <Flex alignContent={'center'} justifyContent={'center'} mb={4}>
          <Skeleton h='24px' w='210px' borderRadius='8px' />
        </Flex>
      )}

      {config?.name && (
        <Text justifySelf='flex-end' align='center' mb={4}>
          © {new Date().getFullYear()} {config?.name}
        </Text>
      )}
    </Flex>
  );
};
